var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"videoContainer",staticClass:"video-container"},[_c('video',{ref:"videoPlayer",staticClass:"video-js vjs-default-skin w-full h-full",attrs:{"playsinline":"","x5-video-player-type":"h5","x5-playsinline":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }